import { getDataMapper, mapField } from "@/shared";

export const mapDirectorPaymentsFromServer = getDataMapper({
    main: mapField("main", {
        id: mapField("id", Number),
        title: mapField("title", String),
        tariffName: mapField("tariff_name", String),
        datePay: mapField("date_pay", String),
        directorTariff: mapField("director_tariff"),
        period: mapField("period", String),
        tariffPeriod: mapField("tariff_period", String),
        sum: mapField("sum", Number),
        paymentSum: mapField("payment_sum", Number),
        paymentMethod: mapField("payment_method"),
        paidByInvoice: mapField("paid_by_invoice", Boolean),
        isComplited: mapField("is_complited", Boolean),
        bonusUsedCount: mapField("bonus_used_count", Number),
    }),
    sum: mapField("sum", Number),
    count: mapField("count", Number),
    average: mapField("average", Number),
    LTV: mapField("LTV", Number),
});
